import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Sparkles, PartyPopper, Briefcase, Users } from 'lucide-react';
import './Events.css';

export const Events = () => {
  const events = [
    {
      icon: <Heart size={40} />,
      title: 'Weddings & Receptions',
      description: 'From intimate ceremonies to grand celebrations, we create magical wedding experiences with our stunning venues, signature lighting, and meticulous attention to detail.',
      features: ['Grand Stage Setups', 'Mandap Ceremonies', 'Baraat Entries', 'Reception Dinners'],
      image: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/fdvfy0n5_Screenshot%202025-10-12%20220615.png'
    },
    {
      icon: <Sparkles size={40} />,
      title: 'Engagements & Ring Ceremonies',
      description: 'Celebrate your commitment in style with our elegant venues perfect for intimate gatherings and special announcements.',
      features: ['Intimate Settings', 'Custom Décor', 'Photography-Friendly Spaces', 'Catering Options'],
      image: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/s95edowc_Screenshot%202025-10-12%20220654.png'
    },
    {
      icon: <PartyPopper size={40} />,
      title: 'Haldi & Mehndi Ceremonies',
      description: 'Our poolside venue and grand lawn create the perfect festive atmosphere for colorful pre-wedding celebrations. Same-day setups available at additional cost.',
      features: ['Poolside Setup', 'Colorful Décor', 'Traditional Ambience', 'Same-Day Availability'],
      image: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/8xltqro8_Screenshot%202025-10-12%20220713.png'
    },
    {
      icon: <PartyPopper size={40} />,
      title: 'Anniversaries & Birthdays',
      description: 'Commemorate life\'s special milestones with celebrations tailored to your vision, from intimate family gatherings to lavish parties.',
      features: ['Flexible Capacity', 'Custom Themes', 'Entertainment Options', 'Full-Service Planning'],
      image: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/obwh9pzr_Screenshot%202025-10-12%20220813.png'
    },
    {
      icon: <Briefcase size={40} />,
      title: 'Corporate Events & Award Nights',
      description: 'Host impressive corporate gatherings, conferences, and award ceremonies in our sophisticated banquet halls with modern amenities.',
      features: ['Professional Setup', 'AV Equipment Ready', 'Spacious Parking', 'Business Catering'],
      image: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/c1mr0m0f_Screenshot%202025-10-12%20220826.png'
    },
    {
      icon: <Users size={40} />,
      title: 'Cultural Events & Celebrations',
      description: 'From festivals to community gatherings, our versatile spaces accommodate diverse cultural celebrations with grace and style.',
      features: ['Adaptable Spaces', 'Cultural Sensitivity', 'Large Capacity', 'Flexible Timing'],
      image: 'https://customer-assets.emergentagent.com/job_luxweddings/artifacts/4sn3e26g_image.png'
    }
  ];

  return (
    <div className="events-page">
      <section className="events-hero">
        <div className="container">
          <span className="section-subtitle text-gold">Celebrations</span>
          <h1 className="hero-medium">Events & Experiences</h1>
          <p className="body-large mt-24">
            We don't just host events – we create unforgettable experiences that transform your special occasions into cherished memories
          </p>
        </div>
      </section>

      <section className="section-padding">
        <div className="container">
          <div className="events-grid">
            {events.map((event, index) => (
              <div key={index} className="event-detail-card">
                <div className="event-image-container">
                  <img src={event.image} alt={event.title} className="event-detail-image" />
                  <div className="event-icon-badge">{event.icon}</div>
                </div>
                <div className="event-detail-content">
                  <h3 className="heading-2 mb-16">{event.title}</h3>
                  <p className="body-regular mb-24">{event.description}</p>
                  <div className="event-features">
                    <h4 className="body-small" style={{ fontWeight: 600, marginBottom: '12px' }}>Includes:</h4>
                    <ul className="feature-list-simple">
                      {event.features.map((feature, idx) => (
                        <li key={idx}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Package Info */}
      <section className="section-padding package-section">
        <div className="container">
          <div className="glass-card package-card">
            <span className="section-subtitle text-gold">Packages</span>
            <h2 className="heading-1 text-center mt-16 mb-24">Comprehensive Event Package</h2>
            <p className="body-large text-center mb-48">
              Pricing <span className="text-gold" style={{ fontSize: '32px', fontWeight: 700 }}>(Upon Request)</span> for a full-day celebration
            </p>
            
            <div className="package-grid">
              <div className="package-section-card">
                <h3 className="heading-3 mb-16">Inclusions</h3>
                <ul className="feature-list-simple">
                  <li>Complete venue access (lawn, hall, poolside)</li>
                  <li>Standard décor, fountains, and lighting</li>
                  <li>12 AC guest rooms</li>
                  <li>Valet & bouncer services</li>
                  <li>Event-day coordination & support</li>
                  <li>Power backup & infrastructure</li>
                </ul>
              </div>
              
              <div className="package-section-card">
                <h3 className="heading-3 mb-16">Optional Add-ons</h3>
                <ul className="feature-list-simple">
                  <li>Same-day haldi/mehndi setups (additional cost)</li>
                  <li>Advanced décor themes</li>
                  <li>Entertainment arrangements</li>
                  <li>Luxury upgrades</li>
                  <li>Extended event hours</li>
                  <li>Custom catering packages</li>
                </ul>
              </div>
            </div>
            
            <div className="text-center mt-48">
              <Link to="/contact" className="btn-primary">
                Request Custom Quote
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-simple">
            <h2 className="hero-medium text-center">Let's Plan Your Perfect Event</h2>
            <p className="body-large text-center mt-24 mb-32">
              Connect with our event coordination team to discuss your vision and requirements
            </p>
            <div className="cta-buttons">
              <a href="https://wa.me/918826372788?text=Hi!%20I'd%20like%20to%20discuss%20my%20event%20requirements." 
                 target="_blank" 
                 rel="noopener noreferrer" 
                 className="btn-primary">
                WhatsApp Us
              </a>
              <Link to="/contact" className="btn-secondary">Contact Form</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Events;
